import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiUrlString } from '../../shared/utility/webFactory';
import { ApiCallService } from '../web-serivces/api-call.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  api = inject(ApiCallService);

  saveProfilePreferences(payload): Observable<unknown> {
    return this.api.singleApiCall(
      `${getApiUrlString('postProfilePreferences')}`,
      'POST',
      payload,
      null,
      null,
      true,
    );
  }

  updateProfilePreferences(payload): Observable<unknown> {
    return this.api.singleApiCall(
      `${getApiUrlString('updateProfilePreferences')}`,
      'PUT',
      payload,
      null,
      null,
      true,
    );
  }
}
